/* __next_internal_client_entry_do_not_use__ Badge auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { NotificationBadge } from "./NotificationBadge";
import { StatusBadge } from "./StatusBadge";
import { BadgeVariant } from "./types";
/**
 * @trackcomponent
 * @link [Docs](https://slate.faire.team/slate/component/badge)
 */ export var Badge = function(props) {
    var variant = props.variant;
    if (variant === BadgeVariant.Notification) {
        return /*#__PURE__*/ _jsx(NotificationBadge, _object_spread({}, props));
    } else {
        return /*#__PURE__*/ _jsx(StatusBadge, _object_spread({}, props));
    }
};
